import React, { Component } from "react";
import { Dialog, DialogTitle, Button, DialogActions, DialogContent, TextField, Typography, FormControl, MenuItem, InputLabel, Select } from "@material-ui/core";
import "./ElevatorDialog.css";
import { Formatter } from "./Util";

export class ElevatorDialog extends Component {
	constructor(props) {
		super(props);
		this.getData();
		this.state = {
			ElevatorData: {},
			open: false,
		};

		this.onClose = this.onClose.bind(this);
		this.saveData = this.saveData.bind(this);
	}

	componentDidUpdate(prevProps) {
		if ((this.props.ElevatorsID !== prevProps.ElevatorsID || this.props.visible !== prevProps.visible) && this.props.visible) {
			this.getData();
		}
	}
	async getData() {
		var res = {};
		if (this.props.ElevatorsID) {
			const data = await fetch("Building/GetElevatorData", {
				method: "Post",
				headers: {
					"Content-Type": "application/json",
				},
				cache: "no-cache",
				body: JSON.stringify({ elevatorsId: this.props.ElevatorsID }),
			});
			res = await data.json();
			res = res[0];
		}
		this.setState({ ElevatorData: res, open: true });
	}

	async saveData() {
		var toSave = this.state.ElevatorData;
		toSave.buildings_id = this.props.BuildingsID;
		await fetch("Building/SaveElevatorData", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify({ elevatorData: toSave }),
		});

		this.onClose();
	}

	dynamicOnChange = (event) => {
		var columnName = null;
		if (event.target.nodeName === "INPUT") {
			columnName = event.target.attributes.columnname.value;
		} else if (event.currentTarget.nodeName === "LI") {
			columnName = event.currentTarget.dataset.columnname;
		}

		var elevatorData = this.state.ElevatorData;
		elevatorData[columnName] = event.target.value;
		if (event.target.type === "checkbox") {
			elevatorData[columnName] = event.target.checked;
		}

		this.setState({ ElevatorData: elevatorData });
	};

	onClose() {
		this.setState({ open: false });
		this.props.OnClose && this.props.OnClose();
	}

	render() {
		var baseData = this.state.ElevatorData;
		var inputProps = { readOnly: false };
		var labelProps = { shrink: true };
		return (
			<Dialog open={this.state.open} onClose={this.onClose} fullWidth={true} maxWidth="md">
				<DialogTitle>{"Elevator " + (baseData.serial_number || "") + (baseData.description ? " - " + baseData.description : "")}</DialogTitle>
				<DialogContent>
					<Typography display="block" variant="subtitle1">
						Elevator Information
					</Typography>
					<TextField variant="outlined" onChange={this.dynamicOnChange} inputProps={{ columnName: "serial_number" }} label="Elevator" className="ticket-control" value={baseData.serial_number} InputProps={inputProps} InputLabelProps={labelProps}></TextField>
					<TextField variant="outlined" onChange={this.dynamicOnChange} inputP inputProps={{ columnName: "description" }} label="Description" className="ticket-control" value={baseData.description} InputProps={inputProps} InputLabelProps={labelProps}></TextField>
					<FormControl variant="outlined" style={{ width: "calc(25% - 10px)", marginTop: "8px" }}>
						<InputLabel id="type-label-id">Elevator Type</InputLabel>
						<Select labelWidth={100} inputProps={{ columnname: "type" }} value={baseData.type} onChange={this.dynamicOnChange} labelId="type-label-id">
							<MenuItem data-columnname="type" value="Hydraulic">
								Hydraulic
							</MenuItem>
							<MenuItem data-columnname="type" value="Wheelchair">
								Wheelchair
							</MenuItem>
							<MenuItem data-columnname="type" value="Traction">
								Traction
							</MenuItem>
						</Select>
					</FormControl>
					<div style={{ padding: "8px" }}></div>
					<FormControl variant="outlined" style={{ width: "calc(25% - 20px)", marginRight: "12px" }}>
						<InputLabel id="track-main-label-id">Track Maintenance?</InputLabel>
						<Select labelWidth={150} inputProps={{ columnname: "type" }} value={baseData.track_maintenance} onChange={this.dynamicOnChange} labelId="track-maint-label-id">
							<MenuItem data-columnname="track_maintenance" value={true}>
								Yes
							</MenuItem>
							<MenuItem data-columnname="track_maintenance" value={false}>
								No
							</MenuItem>
						</Select>
					</FormControl>
					<TextField variant="outlined" label="Days Since Last Maint?" style={{ marginRight: "12px" }} value={baseData.days_since_last_maintenance} InputLabelProps={labelProps} InputProps={{ readOnly: true }}></TextField>
					<FormControl variant="outlined" style={{ width: "calc(25% - 20px)", marginRight: "12px" }}>
						<InputLabel id="out-label-id">Out of Service?</InputLabel>
						<Select labelWidth={110} inputProps={{ columnname: "type" }} value={baseData.out_of_service} onChange={this.dynamicOnChange} labelId="out-label-id">
							<MenuItem data-columnname="out_of_service" value={true}>
								Yes
							</MenuItem>
							<MenuItem data-columnname="out_of_service" value={false}>
								No
							</MenuItem>
						</Select>
					</FormControl>
					{baseData.out_of_service && <TextField variant="outlined" label="Date Out of Service" value={Formatter(baseData.date_out_of_service, "D")} InputLabelProps={labelProps} InputProps={{ readOnly: true }}></TextField>}
					<br></br>
					<Typography display="block" variant="subtitle1" style={{ marginTop: "8px" }}>
						Address Information
					</Typography>
					<TextField variant="outlined" onChange={this.dynamicOnChange} inputProps={{ columnname: "address1" }} label="Street Address 1" className="ticket-control" value={baseData.address1} InputLabelProps={labelProps} InputProps={inputProps}></TextField>
					<TextField variant="outlined" onChange={this.dynamicOnChange} inputProps={{ columnname: "address2" }} label="Street Address 2" className="ticket-control" value={baseData.address2} InputLabelProps={labelProps} InputProps={inputProps}></TextField>
					<TextField variant="outlined" onChange={this.dynamicOnChange} inputProps={{ columnname: "city" }} label="City" className="ticket-control" value={baseData.city} InputProps={inputProps} InputLabelProps={labelProps}></TextField>
					<TextField variant="outlined" onChange={this.dynamicOnChange} inputProps={{ columnname: "state" }} label="State" className="ticket-control" value={baseData.state} InputProps={inputProps} InputLabelProps={labelProps}></TextField>
					<TextField variant="outlined" onChange={this.dynamicOnChange} inputProps={{ columnname: "zip" }} label="Zip" className="ticket-control" value={baseData.zip} InputProps={inputProps} InputLabelProps={labelProps}></TextField>
				</DialogContent>
				<DialogActions>
					<Button onClick={this.saveData} color="primary">
						Save
					</Button>
					<Button onClick={this.onClose} color="primary">
						Close
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}
